var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgElectronicBillingTaxDocument = function SvgElectronicBillingTaxDocument(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}.a{stroke-width:1.5px;}.b{stroke-width:1.2px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.25,22.5H4.75a1,1,0,0,1-1-1V2.5a1,1,0,0,1,1-1h10L20.25,7V21.5A1,1,0,0,1,19.25,22.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.75,
    y1: 18.5,
    x2: 16,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 7.75,
    y1: 14.5,
    x2: 7.75,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.75,
    y1: 9.5,
    x2: 8.75,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.75,14.5v-4a1,1,0,0,1,2,0v4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 10.75,
    y1: 12.5,
    x2: 12.75,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 14.75,
    y1: 9.5,
    x2: 16.75,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 16.75,
    y1: 9.5,
    x2: 14.75,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.25,7h-4.5a1,1,0,0,1-1-1V1.5Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgElectronicBillingTaxDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "electronic-billing-tax-document.8cbdbd08987c95911d8e1d2c3ccb6a74.svg";